import { storyblokEditable } from '@storyblok/react/rsc';
import CmsButton from '@/components/CmsButton';

const Button = ({ blok }) => (
  <div {...storyblokEditable(blok)}>
    <CmsButton
      label={blok.label}
      link={blok.link}
      style={blok.style}
      showArrow={blok.show_arrow}
      fullWidth={blok.full_width}
    />
  </div>
);

export default Button;
